import React from "react";
import { withRouter } from "react-router-dom";
import { TableOp } from "../../../components/table/TableOps.tsx";
import TableComponent from "../../../components/table/TableOps";
import BuscarEvidencias from "./busquedaEvidencias";
import { objectAsParams } from "../../../helpers";
import { Button, Dialog, DialogContent } from "@material-ui/core";
import ImageViewer from "../../../components/imageViever/imageViewer";
import Http from '../../../Http';
import moment from "moment";
import ACCESS from "../../../ACCESS.js";

class EvidenciasEntrega extends TableComponent {
  componentDidMount() {
    this.tableConfig(
      {
        dataUrl: "revision-evidencia/filter",
        deleteUrl: "",
        deleteField: "",
        modUrl: "",
      },
      TableOp.Table(
        "Evidencias",
        [
          { label: "Guia", id: "g_folio" },
          { label: "Fecha Guia", id: "fecha_guia" },
          { label: "Fecha Entrega", id: "fecha_entrega" },
          { label: "Tipo Evidencia", id: "type" },
          { label: "Chofer", id: "chofer" },
          { label: "Cliente", id: "cliente" },
          { label: "Calificación", id: "calificacion" },
          { label: "Origen", id: "origen" },
          { label: "Destino", id: "destino" },
        ],
        [{ id: "review", icon: "edit", access: [ACCESS.REVISION_EVIDENCIAS.VER_EVIDENCIAS] }]
      )
    );
  }

  onSearch = (vals) => {
    vals.start_date = moment(vals.start_date).format("YYYY-MM-DD");
    vals.end_date = moment(vals.end_date).format("YYYY-MM-DD");
    this.config.dataUrl = `revision-evidencia/filter?${objectAsParams(vals)}`;
    this.setState({ filters: vals });
    this.table();
  };

  action = (id, row) => {
    const { tableData } = this.state;
    if (id === "review") {
      this.setState({
        reviewOpen: true,
        row,
        row_index:
          (tableData.page + 1) * tableData.rpp -
          (tableData.rpp - (row.row_index + 1)),
      });
    }
  };

  downloadReport = async () => {
    const { filters } = this.state;
    try {
      let Res = await Http.get(`revision-evidencia/reporte?${objectAsParams(filters)}`, true, 'arraybuffer');
      if (Res) {
        const blob = new Blob([Res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'reporte_calidad_evidencias.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    } catch (error) {
      console.log(error)
    }
  };

  render() {
    const { reviewOpen = false, row, filters, row_index, tableData } = this.state;
    const { hasAccess } = this.context;
    return (
      <div>
        <div>
          { hasAccess(ACCESS.REVISION_EVIDENCIAS.VER_EVIDENCIAS) && (
              <BuscarEvidencias
                onSave={this.onSearch}
              />
            )}
          {filters && (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              {hasAccess(ACCESS.REVISION_EVIDENCIAS.DESCARGAR_REPORTE) && (
              <Button
                variant="contained"
                color={"primary"}
                onClick={() => this.downloadReport()}
              >
                Descargar Reporte
              </Button>)}
            </div>
          )}
          {hasAccess(ACCESS.REVISION_EVIDENCIAS.VER_EVIDENCIAS) && (
              <this.TableRender />
            )}
            {
              reviewOpen &&
              (<Dialog
                open={reviewOpen}
                fullWidth={true}
                maxWidth={"xl"}
                onClose={() => this.setState({ reviewOpen: false })}
              >
                <DialogContent>
                  <ImageViewer 
                    row={row} 
                    filters={filters} 
                    index={row_index} 
                    id_guia={tableData.q && tableData.q.length > 3 && row && row.id_guia}   
                  />
                </DialogContent>
              </Dialog>)
            }
            
        </div>
      </div>
    );
  }
}

export default withRouter(EvidenciasEntrega);
